<template>
  <div class="admin_head">
    <div class="jc_flex">

      <div class="__logo">
        <a href="/Manage/Home">Crygrp Manager</a>
      </div>


      <div class="jc_flex_1">
        
      </div>

      <div class="__home ah_icon">
        <el-tooltip class="item" effect="dark" content="Home Page" placement="bottom">
          <a href="/" target="_blank">
            <i class="el-icon-monitor"></i>
          </a>
        </el-tooltip>
      </div>
      <div class="__home ah_icon">
        <el-tooltip class="item" effect="dark" content="Modify Secret Key" placement="bottom">
          <a href="/Manage/SecretKey">
            <i class="iconfont icon-shenfenshibierenzheng"></i>
          </a>
        </el-tooltip>
      </div>
      <div class="__logout ah_icon">
        <el-tooltip class="item" effect="dark" content="Logout" placement="bottom">
          <a href="javascript:void(0)" @click="logout">
            <i class="iconfont icon-yuanchengchuantou"></i>
          </a>
        </el-tooltip>
      </div>

    </div>
  </div>
</template>

<script>
import { getToken, setToken, removeToken } from '@/utils/auth'

export default {
  name: 'Header',
  props: {
  },
  data() {
    return {
    }
  },
  methods: {
    logout(){
      removeToken();
      this.$router.push({ path: '/Login' });
      return false;
    }
  } 
};
</script>

<style lang="less" scoped>
.admin_head{
  .__logo{
    padding-left: 20px;
    a{
      display: block;
      font-size: 18px;
      line-height: 40px;
      font-weight: 700;
      color: #FFF !important;
      text-transform: uppercase;
      padding: 10px 0;
    }
  }
  .ah_icon{
    border-left: 1px solid rgba(255,255,255,0.05);
    a{
      display: block;
      font-size: 18px;
      line-height: 40px;
      color: rgba(255,255,255,0.63) !important;
      text-transform: uppercase;
      padding: 10px 20px;
      &:hover{
        background: rgba(255,255,255,0.03);
        color: rgba(255,255,255,0.83) !important;
      }
      .iconfont{
        font-size: 24px;
      }
    }
  }
}
</style>